"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const WishError_1 = require("./WishError");
const WISH_URL = process.env.WISH_URL;
const WISH_BASIC_AUTH_USER = process.env.WISH_BASIC_AUTH_USER;
const WISH_BASIC_AUTH_PASSWORD = process.env.WISH_BASIC_AUTH_PASSWORD;
class WishClient extends base_client_1.ApiBasicAuthClient {
    constructor(url = WISH_URL, user = WISH_BASIC_AUTH_USER, password = WISH_BASIC_AUTH_PASSWORD) {
        super({
            baseURL: `${url}/v1/`,
            basicAuthUser: user,
            basicAuthPassword: password,
        });
        if (!user || !password) {
            commons_logs_1.log.warn("Missing WISH_BASIC_AUTH_USER and WISH_BASIC_AUTH_PASSWORD environment variables");
        }
    }
    async getSellerConnectionStatus(sellerId) {
        try {
            return await this.get(`/seller/${sellerId}/connectionstatus`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.SELLER_NOT_FOUND]);
        }
    }
    async getSeller(sellerId) {
        try {
            return await this.get(`/seller/${sellerId}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.SELLER_NOT_FOUND]);
        }
    }
    async updateSeller(sellerId, update) {
        try {
            return await this.put(`/seller/${sellerId}`, update);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.SELLER_NOT_FOUND]);
        }
    }
    async getAllSellers(limit, offset, filters = {}) {
        try {
            return await this.get(`/sellers`, Object.assign({ limit,
                offset }, filters));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async authorizeSeller(sellerId, authorizationCode) {
        try {
            return await this.put(`/seller/${sellerId}/authorization`, {
                authorizationCode,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.ACCESS_TOKEN_ERROR, WishError_1.WishError.DUPLICATE_MERCHANT_ID, WishError_1.WishError.DUPLICATE_TOKEN]);
        }
    }
    async refreshSeller(sellerId) {
        try {
            return await this.post(`/refresh/seller/${sellerId}`, {});
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.REFRESH_ALREADY_IN_PROGRESS, WishError_1.WishError.SELLER_NOT_FOUND]);
        }
    }
    async getDskuStateCoverage(dsku) {
        try {
            return await this.get(`/availability/dsku/${dsku}/coverage/twoday`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getStateCoverageByServiceLevel(dsku) {
        const coverage = await this.getDskuStateCoverage(dsku);
        return { 2: coverage };
    }
    async enableFastTag(sellerId, dsku) {
        try {
            await this.put(`/product/seller/${sellerId}/fast-tag/enable`, [dsku]);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async disableFastTag(sellerId, dsku) {
        try {
            await this.put(`/product/seller/${sellerId}/fast-tag/disable`, [dsku]);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.SELLER_NOT_FOUND, WishError_1.WishError.NO_WISH_EXPRESS_WAREHOUSE]);
        }
    }
    async updateLinkForDsku(sellerId, dsku, variationIdentifier) {
        try {
            return await this.put(`/product/seller/${sellerId}/dsku/${dsku}/variant`, {
                variationIdentifier,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WishError_1.WishError.WISH_PRODUCT_IDENTIFIER_NOT_FOUND]);
        }
    }
    async getLinksForDsku(sellerId, dsku) {
        try {
            return await this.get(`/product/seller/${sellerId}/dsku/${dsku}/links`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async isFastTagEnabled(sellerId, dsku) {
        try {
            const { isActive } = await this.get(`/product/seller/${sellerId}/dsku/${dsku}/active`);
            return isActive;
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async removeLinkFromDsku(sellerId, dsku, variationSku) {
        try {
            await this.delete(`/product/seller/${sellerId}/dsku/${dsku}/link`, {
                variationSku,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                WishError_1.WishError.SELLER_NOT_FOUND,
                WishError_1.WishError.VARIATION_NOT_FOUND,
                WishError_1.WishError.NO_WISH_EXPRESS_WAREHOUSE,
            ]);
        }
    }
}
exports.WishClient = WishClient;
//# sourceMappingURL=WishClient.js.map